import { render, staticRenderFns } from "./FloatingHeader.vue?vue&type=template&id=41d2e4a4&lang=true&"
import script from "./FloatingHeader.vue?vue&type=script&lang=js&"
export * from "./FloatingHeader.vue?vue&type=script&lang=js&"
import style0 from "./FloatingHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports